<template>
  <v-dialog
    :model-value="open"
    max-width="480"
    @update:model-value="handleClose">
    <v-card class="pa-4">
      <div class="d-flex align-center mb-4">
        <v-icon
          :color="iconColor"
          size="28"
          class="mr-3">
          {{ icon }}
        </v-icon>
        <span class="text-h6">{{ title }}</span>
      </div>

      <div class="mb-4">
        <p class="mb-2">{{ message }}</p>
        <div
          v-if="hasNonVisible"
          class="warning-box">
          <v-icon
            color="warning"
            size="20"
            class="mr-2">
            mdi-alert
          </v-icon>
          <span>
            <strong>{{ nonVisibleCount }}</strong> of these {{ itemType }} are
            not currently visible in your view.
          </span>
        </div>
      </div>

      <div class="d-flex justify-end gap-2">
        <v-btn
          variant="text"
          @click="handleClose">
          Cancel
        </v-btn>
        <v-btn
          :color="confirmColor"
          :loading="loading"
          variant="flat"
          @click="handleConfirm">
          {{ confirmLabel }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Confirm Action',
  },
  message: {
    type: String,
    default: 'Are you sure you want to proceed?',
  },
  confirmLabel: {
    type: String,
    default: 'Confirm',
  },
  confirmColor: {
    type: String,
    default: 'primary',
  },
  icon: {
    type: String,
    default: 'mdi-help-circle',
  },
  iconColor: {
    type: String,
    default: 'primary',
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  nonVisibleCount: {
    type: Number,
    default: 0,
  },
  itemType: {
    type: String,
    default: 'items',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'confirm']);

const hasNonVisible = computed(() => props.nonVisibleCount > 0);

function handleClose() {
  emit('close');
}

function handleConfirm() {
  emit('confirm');
}
</script>

<style scoped>
.warning-box {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.4);
  border-radius: 4px;
  margin-top: 8px;
}

.gap-2 {
  gap: 8px;
}
</style>
